/*
用来在内存保存一些数据的工具模块
 */
import history from './history';
import ajax from "../api/ajax";
import {message} from 'antd'
import {baseUrl} from "../api";
const convertUserInfo=(userData)=>{
    let permissions = []
    if(userData && userData.authorityDos )
        permissions = userData.authorityDos
    let userInfo = {name:userData.name||userData.username,username:userData.username,permissions:permissions,authCode:userData.authorizationCode}
    return userInfo
}
const getUserInfo=()=>{
    let userInfo = window.sessionStorage.getItem("userInfo")
    if(userInfo){
        userInfo = JSON.parse(userInfo)
        if(userInfo.username) {
            return Promise.resolve(userInfo)
        }
    }else{
        return new Promise((resolve, reject)=>{
            return ajax(baseUrl + '/auth/user').then((resp)=>{
                if(resp.code !=200){
                    reject(null)
                }else{
                    let userInfo = convertUserInfo(resp.data)
                    window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
                    resolve(userInfo)
                }
            }).catch((resp)=>{
                reject(null)
            })
        })
    }
    return Promise.reject(null)
}
const ayncCheckLogin=()=>{
    return new Promise((resolve, reject) => {
        return getUserInfo().then((userInfo)=>{
            if(userInfo !=null) {
                resolve(true);
            }else{
                reject(false);
            }
        }).catch(()=>{
            reject(false);
        })
    })
}
export {getUserInfo,ayncCheckLogin}
export default {
    user: {}, // 保存当前登录的user
    authorizes:[],
    checkLogin:()=>{
        ayncCheckLogin().then(()=>{
            if(history.location.pathname ==="/login"){
                history.push("/")
            }
        },()=>{
            if(history.location.pathname !="/login"){
                history.push("/login")
            }
        })
    },
    doLogin:(userData)=>{
        if(userData) {
            let userInfo = convertUserInfo(userData)
            window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
        }
        history.push("/")
    },
    doLogout:()=>{
        let result = ajax(baseUrl + '/logout', )
        result.then(function() {
            window.sessionStorage.removeItem("userInfo");
            history.push("/login")
        }).catch(()=>{
            window.sessionStorage.removeItem("userInfo");
            history.push("/login")
        });

    },
    resetUserInfo:()=>{
        let result = ajax(baseUrl + '/auth/clear', )
        result.then(function() {
            window.sessionStorage.removeItem("userInfo");
            getUserInfo().then((userInfo)=>{
                message.info('权限刷新成功')
            })
        }).catch(()=>{
            window.sessionStorage.removeItem("userInfo");
        });
    }
}